import { get, post } from '@api/request';

export async function fetchCyclomediaCredentials(
  { userService },
  authenticationToken,
) {
  const url = `${userService}/trueprodigy/cyclomedialoginconfig`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPreference(
  { userService },
  authenticationToken,
  { userId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/preference/appraisal`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function persistPreference(
  { userService },
  authenticationToken,
  { userId, data },
) {
  const url = `${userService}/trueprodigy/user/${userId}/preference/appraisal`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchPropertyTypes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/propertytype`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchRoles({ userService }, authenticationToken) {
  const url = `${userService}/trueprodigy/module/13/roles`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSystemAppraisalYear(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/currentyear`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraisalYears(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/allyears`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraisalYearsWithStatus(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/allyearswithstatus`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraisers({ userService }, authenticationToken) {
  const url = `${userService}/trueprodigy/user/appraisal/byattribute/Appraiser`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraisalCompanies(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/appraisalcompanies`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraisalIncomingCalls(
  { appraisalService },
  authenticationToken,
  { phoneNumber }
) {
  const url = `${appraisalService}/appraisal/property/searchbyphonenumber?phoneNumber=${phoneNumber}`;
  const { body } = await get(authenticationToken, url);
  return body;
}